import Archive from '../class/Archive';

class Team {
	constructor(className) {
		this.sections = document.querySelectorAll(`.${className}`);
		this.sections.forEach((section) => new Section(section));
	}
}

class Section {
	constructor(section) {
		this.section = section;
		new Archive(section, {
			prefetch: true,
			containerSelector: 'main',
			scrollAnchorSelector: 'main',
		});
		this.section.classList.add('visible');
		const teamMembers = document.querySelectorAll('.team__member');
		teamMembers.forEach((member) => member.addEventListener('click', this.removeTeams));
	}
	removeTeams() {
		const teamsContainer = document.querySelector('.team__members');
		if (teamsContainer.classList.contains('hidden')) {
			teamsContainer.classList.remove('hidden');
		} else {
			teamsContainer.classList.add('hidden');
		}
	}
}

export default Team;
